import { InjectionToken } from '@angular/core';
import type { Clerk } from '@clerk/clerk-js';

export type PicflowClerkLoader = () => Promise<Clerk>;
export const PICFLOW_CLERK = new InjectionToken<PicflowClerkLoader>('clerk');
